<template>
  <b-modal
    id="modal-nuevo-pago"
    centered
    title="Generar partidos"
    ok-title="GUARDAR"
    cancel-title="CANCELAR"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    @hidden="onlyClose"
    v-model="$store.state.someVariables.showConfigEspejo"
  >
    <h4>{{ categoriaSeleccionada.label }}</h4>
    <h5>{{ etapa.label }} Grupo: {{ grupo.grupo }}</h5>
    <b-row>
      <b-col md="12">
        <!-- {{ campeonatoSeleccionado }} -->
        <!-- {{ categoriaSeleccionada }} -->
        <!-- {{ etapa }} -->
        <!-- {{ grupo }} -->
        <v-select
          placeholder="Seleccionar Etapa de referencia"
          :options="listEtapas"
          class="mb-1 mt-1 select-size-sm"
          @input="validaEtapa"
          v-model="etapaSelected"
        />
      </b-col>
      <b-col md="12" v-if="grupoEvaluar.num_fechas != 0">
        <span><b>Seleccione una opción</b></span>
        <div class="demo-inline-spacing">
          <b-form-radio
            v-model="opcion"
            name="radio-rol"
            value="1"
            class="mt-1"
          >
            Agregar {{ grupoEvaluar.num_fechas }} fechas conservando el orden
          </b-form-radio>
          <b-form-radio
            v-model="opcion"
            name="radio-rol"
            value="2"
            class="mt-1"
          >
            Agregar {{ grupoEvaluar.num_fechas }} fechas en modalidad
            espejo(último fecha pasa a ser la
            {{ Number(grupoEvaluar.num_fechas) + 1 }}
            fecha y sucesivamente)
          </b-form-radio>
        </div>
      </b-col>
    </b-row>

    <template #modal-footer>
      <div class="w-100">
        <template v-if="!showLoading">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="saveEspejo"
          >
            Generar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
          <span>Espere..</span>
        </div>
        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px ;z-index:100"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BModal,
  // BForm,
  // BFormInput,
  // BFormGroup,
  //   BFormInvalidFeedback,
  //   BFormValidFeedback,
  // BFormTextarea,
  BFormRadio,
  // BFormFile,
  BButton,
  BSpinner,
  BAlert,
  BRow,
  BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { heightFade } from '@core/directives/animations'
// import flatPickr from 'vue-flatpickr-component'
import store from '@/store'
import vSelect from 'vue-select'
import {
  URL,
  USER,
  ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BModal,
    // BForm,
    // BFormInput,
    // BFormGroup,
    // BFormInvalidFeedback,
    // BFormValidFeedback,
    // BFormTextarea,
    BFormRadio,
    // BFormFile,
    BButton,
    BSpinner,
    BAlert,
    // flatPickr,
    vSelect,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
    heightFade,
  },
  props: {
    listEtapas: Array,
    categoriaSeleccionada: Object,
    etapa: Object,
    grupo: Object,
    campeonatoSeleccionado: Object,
    idModalidadGrupoInsert: String,
  },
  setup(props, { emit }) {
    const selected = ref(null)
    const inputTitulo = ref('')
    const croppaFoto = ref({})
    const file = ref(false)
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const messageError = ref('')
    const variante = ref('danger')
    const showLoading = ref(false)
    const hasError = ref(false)
    const fileModel = ref(null)
    const opcion = ref(null)
    const { postApi } = apiCall()
    // const etapaSelected = computed(() => props.etapa)
    const etapaSelected = ref(null)
    const grupoEvaluar = ref({ num_fechas: 0 })

    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function resetModal() {
      // bvModalEvt.preventDefault()
      // emit('recargar', props.arbitroSelected.id_gremio_arbitral)
      hasError.value = false
      etapaSelected.value = null
      showLoading.value = false
      countDownChanged(0)
      opcion.value = null
      grupoEvaluar.value = { num_fechas: 0 }
      // initPlayer()
      //       this.$emit('closeModal', false)
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_CONFIG_ESPEJO', false)
      showLoading.value = false
      resetModal()
    }
    function validaEtapa(item) {
      // console.log(item)
      if (item != null) {
        grupoEvaluar.value = etapaSelected.value.grupos.find(
          // eslint-disable-next-line
          element =>
            // eslint-disable-next-line
            element.grupo === props.grupo.grupo
        )
        // console.log(resultado)
        if (etapaSelected.value.value > props.etapa.value) {
          showMessageAlert(
            'danger',
            // eslint-disable-next-line
            'la etapa seleccionada no debe ser mayor a la etapa actual'
          )
          etapaSelected.value = { label: 'Seleccione etapa referencia' }
          opcion.value = null
        }
      }
    }
    async function saveEspejo() {
      showLoading.value = true
      if (opcion.value == null) {
        showMessageAlert('danger', 'Debe seleccionar una opción')
      } else {
        const data = {
          id_campeonato: props.campeonatoSeleccionado.value,
          id_categoria: props.categoriaSeleccionada.value,
          etapa_insertar: props.etapa.value,
          etapa_buscar: etapaSelected.value.value,
          grupo_buscar: grupoEvaluar.value.grupo,
          modalidad: opcion.value,
          num_fechas: grupoEvaluar.value.num_fechas,
          id_modalidad_grupo: props.idModalidadGrupoInsert,
          num_partidos_fecha: grupoEvaluar.value.num_partidos_fecha,
          // rol: USER().rol,
        }
        // console.log(data)
        const path = 'ApiFixture/generarEspejos'
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          showLoading.value = false
          emit('recargaFixture', {
            numFechas: data.num_fechas,
            espejo: response.espejo,
          })
          onlyClose()
        }
      }
      showLoading.value = false
    }

    return {
      inputTitulo,
      selected,
      croppaFoto,
      file,
      dismissCountDown,
      dismissSecs,
      countDownChanged,
      messageError,
      variante,
      showLoading,
      hasError,
      showMessageAlert,
      onlyClose,
      fileModel,
      USER,
      ROLES,
      opcion,
      saveEspejo,
      etapaSelected,
      validaEtapa,
      grupoEvaluar,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
</style>
